import config from "config/config";
import type { LanguageCode } from "config/languages";
import { isDefaultLanguage } from "utils/isDefaultLanguage";
import type { BuildLanguagesListsParams, BuildLanguagesListsReturnValue } from "./buildLanguagesLists.d";

const buildLanguagesLists = (
  languages: BuildLanguagesListsParams["languages"],
  pageName: BuildLanguagesListsParams["pageName"],
  cmsLanguagesData: BuildLanguagesListsParams["cmsLanguagesData"],
  getPageUrl: BuildLanguagesListsParams["getPageUrl"]
): BuildLanguagesListsReturnValue => {
  const suggestedLanguages = [];
  const selectLanguages = [];

  Array.from(languages.entries()).map(([key, { name, languageFlag, popularLanguage, hidden, localDomain }]) => {
    let localizedPagePath = "";

    if (cmsLanguagesData?.length) {
      const cmsPageData = cmsLanguagesData.filter((item) => {
        const locale = item.full_slug.split("/")[0] as LanguageCode;
        const isParentLanguageSame = locale.split("-")[0] === key.split("-")[0];

        return isDefaultLanguage(locale) ? isParentLanguageSame : locale === key;
      });

      const slug = cmsPageData[0]?.full_slug.split(/\/(.+)?/)[1];
      localizedPagePath = slug ? `/${key}/${slug}` : `/${key}/`;
    } else {
      localizedPagePath = getPageUrl(key, pageName);
    }

    if (hidden) return {};

    const lang = {
      id: key,
      name,
      icon: languageFlag,
      href: localizedPagePath,
    };

    if (localDomain) {
      lang.href = localDomain + lang.href;
    } else {
      lang.href = config.websiteUrl + lang.href;
    }

    return popularLanguage ? suggestedLanguages.push(lang) : selectLanguages.push(lang);
  });

  return {
    suggestedLanguages,
    selectLanguages,
  };
};

export default buildLanguagesLists;
